<div
  class="bg-white shadow rounded border p-2 w-auto h-auto m-3 cursor-pointer"
  (click)="ViewProduct(product._id)"
  (click)="scrollToTop()"
>
  <div class="relative rounded">
    <p
      class="addbtn absolute left-0 text-md text-white w-16 my-2 mb-3 shadow-lg shadow-purple-400 rounded-r-full z-10"
    >
      {{
        ((product?.priceInventoryShippingInfo?.MRP -
          product?.priceInventoryShippingInfo?.sellingPrice) /
          product?.priceInventoryShippingInfo?.MRP) *
          100 | number: "1.0-0"
      }}% off
    </p>
    <img
      [src]="imageUrl + product.images[0]"
      [alt]="product.productDetails?.productName"
      loading="lazy"
      decoding="async"
      class="h-52 mt-5 w-full lg:mt-3 lg:object-contain transform transition duration-500 hover:scale-95"
    />

    <div class="m-4">
      <div class="flex items-center mt-2" *ngIf="product?.averageRating > 0">
        <ng-container
          *ngFor="
            let star of getRatingArray(product?.averageRating);
            let i = index
          "
        >
          <svg
            class="w-4 h-4 mx-1"
            [ngClass]="{ 'text-yellow-500': star, 'text-gray-300': !star }"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.958a1 1 0 00.95.69h4.163c.969 0 1.372 1.24.588 1.81l-3.37 2.448a1 1 0 00-.364 1.118l1.287 3.958c.3.921-.755 1.688-1.54 1.118l-3.371-2.448a1 1 0 00-1.175 0l-3.37 2.448c-.785.57-1.84-.197-1.54-1.118l1.287-3.958a1 1 0 00-.364-1.118L2.03 9.385c-.785-.57-.38-1.81.588-1.81h4.163a1 1 0 00.95-.69l1.286-3.958z"
            />
          </svg>
        </ng-container>
        <span class="text-gray-600 text-sm ml-2"
          >({{ product?.averageRating || 0 }}/5)</span
        >
      </div>
      <span class="text-gray-600 font-medium mr-3 uppercase text-xs">{{
        product?.productDetails.brand
      }}</span>

      <p class="text-lg font-bold text-black truncate block capitalize">
        {{ product.productDetails.productName }}
      </p>
      <div class="flex items-center">
        <del class="text-red-600">
          <p class="text-sm text-red-600 cursor-auto ml-2">
            ₹{{ product?.priceInventoryShippingInfo?.MRP }}
          </p>
        </del>
        <p class="text-lg font-semibold text-purple-700 cursor-auto">
          &nbsp;₹{{ product?.priceInventoryShippingInfo.sellingPrice }}
        </p>
      </div>
      <div class="flex">
        <img src="./assets/images/delivery.png" class="w-5 ml-2" />
        <p class="text-xs text-blue-500 font-semibold text-green-500">
          &nbsp;Free Delivery
        </p>
      </div>
      <a
        class="addbtn inline-block hover:bg-indigo-600 text-white p-2 m-1 rounded-lg"
        >Buy Now</a
      >
      <span
        *ngIf="product?.currentPromotion?.isActive"
        class="bg-red-00 py-1 px-2 rounded-full text-white font-bold uppercase"
        >Deals On</span
      >
    </div>
    <div *ngIf="">
      <h1>Data Not Found</h1>
    </div>
    <!-- </div> -->
  </div>
</div>
